import { Box, Text } from '@timelyapp/react';
import classNames from 'classnames';
import React from 'react';
import type { ProjectBase } from 'types/project';
import { prefixHexColor } from 'utils/colors';
import { getProjectColor } from 'utils/project';
import styles from './column.module.scss';
import { COLUMN_SIZE_LARGE } from './constants';
import HeaderWithMenu from './HeaderWithMenu';
import type { DatatableCellRenderer, DatatableColumnGetter } from './types';

export const getProjectColumn: DatatableColumnGetter<ProjectBase> = (id: string) => ({
  id,
  header: props => (
    <HeaderWithMenu
      {...props}
      label="Project"
      sortLabelType="string"
      filterTriggerSelector='[data-testid="project-filter-dropdown"]'
    />
  ),
  minSize: COLUMN_SIZE_LARGE,
  enableResizing: true,
  enableSorting: true,
  meta: {
    numeric: false,
    label: 'Project',
    mandatory: true,
    getValue: (project: ProjectBase) => `${project.name}`,
  },
  cell: ProjectCell,
});

export const ProjectCell: DatatableCellRenderer<ProjectBase> = ({ getValue }) => {
  const project = getValue();
  return (
    <Box.Row className={classNames(styles.project, 'fs-mask')} alignItems="center">
      <span
        className={styles.color}
        style={{ backgroundColor: prefixHexColor(getProjectColor(project)) }}
      />
      <Text size="small">{project.name}</Text>
    </Box.Row>
  );
};
